<template>
  <section class="box has-border-light">
    <div class="p-5">
      <SkeletonView :height="40" />
      <SkeletonView :height="35" class="m-t-5" />
      <SkeletonView :height="70" class="m-t-5" />
      <SkeletonView :height="90" class="m-t-5" />
      <SkeletonView :height="48" class="m-t-5" />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SkeletonView from '@/modules/core/ui/components/wrappers/SkeletonView.vue';

export default defineComponent({
  name: 'FinancialAdvisorProUpsellAnnualPlanCardSkeleton',
  components: { SkeletonView }
});
</script>
